const headers = {
  name: "Purchase Order",
  navigate: {
    path: [
      {
        name: "Orders",
        path: "/app/purchases/grn",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
